export default __webpack_public_path__ + "static/media/005-burger.0a20f32f.svg";